import { FileUploaderComponent } from './shared-components/file-uploader/file-uploader.component';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { AutomationService } from './automation.service';
import { AUTOMATION_ROUTER_PROVIDER } from './automation.routes';
import { ServicesSpecificationNamesAddComponent } from './services-specification-names/add/services-specification-names-add.component';
import { ServicesSpecificationNamesListComponent } from './services-specification-names/list/services-specification-names-list.component';
import { AutomationProcessesComponent } from './automation-proccesses/automation-proccesses.component';
import { TDRSCreationComponent } from './tdrs-creation/tdrs-creation.component';
import { AutomationComponent } from './automation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { ServicesSpecificationNamesEditComponent } from './services-specification-names/edit/services-specification-names-edit.component';
import { AutomationHeaderComponent } from './automation-header/automation-header.component';
import { TDRSValidationComponent } from './tdrs-validation/tdrs-validation.component';
import { ExcelSheetsExamplesComponent } from './excel-sheets-examples/excel-sheets-examples.component';
import { AutomationAdministrationComponent } from './automation-administration/automation-administration.component';
import { UserInfoNilTransformation } from './userinfo-nil-transformation/userinfo-nil-transformation.component';

@NgModule({
    declarations: [
        AutomationComponent,
        ServicesSpecificationNamesAddComponent,
        ServicesSpecificationNamesListComponent,
        ServicesSpecificationNamesEditComponent,
        AutomationProcessesComponent,
        TDRSCreationComponent,
        TDRSValidationComponent,
        AutomationHeaderComponent,
        FileUploaderComponent,
        ExcelSheetsExamplesComponent,
        AutomationAdministrationComponent,
        UserInfoNilTransformation
    ],
    imports: [
        HttpModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserModule,
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'main',
            cancelButtonType: 'main-outline' // set defaults here
        }),
        AUTOMATION_ROUTER_PROVIDER
    ],
    providers: [AutomationService]
})
export class AutomationModule { }



// WEBPACK FOOTER //
// ./src/app/automation/automation.module.ts